// Library Import
import {
  Box,
  Flex,
  VStack,
  HStack,
  Text,
  Input,
  Button,
  useToast,
  useColorModeValue,
  Icon,
  Heading,
  Grid,
  GridItem,
  Tooltip,
  Fade,
  ScaleFade,
  Select,
  Stack,
  Link,
  RadioGroup,
  Radio,
  Alert,
  AlertIcon,
  FormLabel,
  FormControl,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// Icon Imports
import { FaUpload, FaChevronRight } from "react-icons/fa";
import { DownloadIcon } from "@chakra-ui/icons";

// Local Imports
import Toasts from "../Toasts";
import { redSetToast } from "../../redux/slices/userSlice";
import {
  downloadExcelTemplate,
  getTotalStudentCount,
  uploadFileData,
} from "../../redux/thunks/adminthunk";
import { redResetUserAdded } from "../../redux/slices/adminSlice";

const ExcelUpload = ({ type }) => {
  const dispatch = useDispatch();

  const accentColor = useColorModeValue("blue.500", "blue.300");

  const [activeTab, setActiveTab] = useState(type);

  const {
    userAdded,
    userFileAdded,
    addPremiumUser,
    error,
    metaDetails,
    loading,
    totalStudents,
  } = useSelector((state) => state.stateAdminReducer);

  useEffect(() => {
    if (userFileAdded) {
      dispatch(
        redSetToast({
          title: "User File Added Successfully",
          status: "success",
        })
      );
      dispatch(getTotalStudentCount());
      dispatch(redResetUserAdded());
    }

    dispatch(getTotalStudentCount());
  }, [userAdded, userFileAdded, addPremiumUser]);

  const handleFileUpload = (e) => {
    if (!e.target.files[0]) {
      dispatch(redSetToast({ title: "Please Select a file", status: "error" }));
      return;
    }

    dispatch(uploadFileData({ file: e.target.files[0], type: "user" }));
  };

  return (
    <Flex
      as="main"
      justify="center"
      bg="gray.200"
      align="center"
      w="100%"
      h="100%"
    >
      <Toasts />
      <Flex
        w="97%"
        h="95%"
        borderRadius="20px"
        p={10}
        bg="white"
        direction="column"
        justifyContent="center"
        alignItems="center"
        overflowY="scroll"
      >
        <Box h="100%" mt={"10rem"}>
          <VStack
            spacing={8}
            align="stretch"
            h="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Heading size="xl" color={accentColor}>
              Excel File Upload
            </Heading>
            <Text fontSize="lg" textAlign="center">
              Upload an Excel file containing user information. The file should
              have columns for Name, Email, Year, Branch and College Name.
            </Text>
            <Box
              flex={1}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Tooltip label="Click to select file" placement="top">
                <Button
                  as="label"
                  htmlFor="file-upload"
                  size="lg"
                  height="200px"
                  width="200px"
                  borderRadius="full"
                  colorScheme="blue"
                  cursor="pointer"
                  _hover={{ transform: "scale(1.05)" }}
                  transition="all 0.2s"
                  isLoading={loading}
                >
                  <VStack>
                    <Icon as={FaUpload} boxSize={12} />
                    <Text>Select File</Text>
                  </VStack>
                  <Input
                    type="file"
                    id="file-upload"
                    accept=".xlsx, .xls, .csv"
                    onChange={handleFileUpload}
                    display="none"
                  />
                </Button>
              </Tooltip>
            </Box>
          </VStack>
        </Box>

        {totalStudents && (
          <Box
            p={8}
            bg="gray.100"
            borderRadius="lg"
            boxShadow="sm"
            maxW="800px"
            mx="auto"
            mt="10px"
          >
            <Text fontWeight="medium" mb={2}>
              Total student count : {totalStudents || 0}
            </Text>
          </Box>
        )}

        <Box
          p={8}
          bg="gray.100"
          borderRadius="lg"
          boxShadow="sm"
          maxW="800px"
          mx="auto"
          mt="10px"
        >
          <VStack align="stretch" spacing={6}>
            {/* Step 1 */}
            <Box>
              <Text fontWeight="medium" mb={2}>
                step 1: Download the given excel sheet
              </Text>
              <Stack direction={{ base: "column", md: "row" }} spacing={4}>
                <Link
                  color="blue.500"
                  display="inline-flex"
                  alignItems="center"
                  onClick={() => dispatch(downloadExcelTemplate("user"))}
                >
                  <Icon as={DownloadIcon} mr={1} />
                  ImportTemplate.xlsx
                </Link>
              </Stack>
            </Box>

            {/* Step 2 */}
            <Box>
              <Text fontWeight="medium">
                step 2: Fill out your learners details in the specified format
              </Text>
            </Box>

            {/* Step 3 */}
            <Box>
              <Text fontWeight="medium" mb={4}>
                step 3: After you have filled out the details, upload your excel
                sheet
              </Text>
            </Box>
          </VStack>
        </Box>
      </Flex>
    </Flex>
  );
};

export default ExcelUpload;
